import React, { useState } from "react";
import { api } from "../../config/api";
import DefaultGrid from "../Default/DefaultGrid";
import { useNavigate } from "react-router-dom";
import { useFilters } from "../Filters/UseFilter";
import { FrontEndRoutes } from "../../config/front-end-routes";
import { BackEndRoutes } from "../../config/back-end-routes";
import ModalDelete from "../Modal/ModalDelete";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

interface Pedidos {
  id_pedido: number;
  nr_pedido: string;
  nome_usuario_imp: string;
  data_emissao: string;
  previsao_entrega: string;
  total: string;
}

interface props {
  requests: any;
  reload: any;
}

const GridRequests: React.FC<props> = ({ requests, reload }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [deleting, setDeleting] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false)
  const [selectedItem, setSelectedItem] = useState<Pedidos | null>(null);
  const { filters, handleFilterChange } = useFilters([]);
  const columns = [
    {
      key: "", render: (item: any) => (
        <span className=" d-flex justify-content-center align-items-center ">
          {item.data_importacao !== null && item.data_importacao !== "0000-00-00 00:00:00" ?
            <FontAwesomeIcon className="text-info fa-lg " icon={faCircle} /> : ''}
          {item.flg_concluido !== 1 ?
            <FontAwesomeIcon className="text-warning fa-lg " icon={faCircle} /> : ''}
        </span>

      )
    },
    { key: "nr_pedido", label: "Nº Pedido", filterType: "text" as const },
    { key: "nome_usuario_imp", label: "Cliente", filterType: "text" as const, class: "col-2 col-md-3 col-sm-4 hidden-xs-down" },
    { key: "data_emissao", label: "Emissão", filterType: "date" as const },
    { key: "previsao_entrega", label: "Entrega", filterType: "date" as const },
    { key: "total", class: "text-lg-end", label: "Total", filterType: "text" as const },
  ];

  const handleDelete = () => {
    setDeleting(true);

    api.delete(BackEndRoutes.routes.PEDIDOS.DELETE.replace(':id', selectedItem?.id_pedido))
      .then(() => {
        reload();
      })
      .catch((error) => {
        console.error("Erro ao deletar cliente:", error);
        toast("Não foi possível deletar o cliente.");
      })
      .finally(() => {
        setDeleting(false);
        setShowModal(false);
        setSelectedItem(null);
      });
  };

  

  return (
    <div>
      <DefaultGrid
        title="Lista de Pedidos"
        onAdd={() => { navigate(FrontEndRoutes.PEDIDOS.CREATE); }}
        columns={columns}
        filters={filters}
        handleFilterChange={handleFilterChange}
        items={requests}
        itemsPerPage={10}
        onReload={reload}
        onEdit={(item) => { navigate(FrontEndRoutes.PEDIDOS.EDIT.replace(":id", item.id_pedido)) }}
        onDelete={(item: any) => { setShowModal(true); setSelectedItem(item) }}
      />

      <ModalDelete
        show={showModal}
        title="Confirmar Delete"
        message={`Deseja confirmar a exclusão do pedido : ${selectedItem?.id_pedido}?`}
        loading={deleting}
        onConfirm={handleDelete}
        onCancel={() => {
          setShowModal(false);
          setSelectedItem(null);
        }}
      />
    </div>
  )
}

export default GridRequests